import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { OpeningLead } from './components/OpeningLead';
import { PainAgitation } from './components/PainAgitation';
import { EmotionalAmplification } from './components/EmotionalAmplification';
import { DreamTransformation } from './components/DreamTransformation';
import { WhyOthersFail } from './components/WhyOthersFail';
import { UniqueMechanism } from './components/UniqueMechanism';
import { ServicePresentation } from './components/ServicePresentation';
import { StoryCredibility } from './components/StoryCredibility';
import { BenefitsTable } from './components/BenefitsTable';
import { RiskReversal } from './components/RiskReversal';
import { UrgencyScarcity } from './components/UrgencyScarcity';
import { MainCTA } from './components/MainCTA';
import { OneLiners } from './components/OneLiners';
import { FAQSection } from './components/FAQSection';
import { MapSection } from './components/MapSection';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-brand-bg-dark text-white font-sans selection:bg-brand-gold selection:text-brand-bg-dark" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicePresentation data-id="element-4" />
        <OpeningLead data-id="element-5" />
        <PainAgitation data-id="element-6" />
        <EmotionalAmplification data-id="element-7" />
        <DreamTransformation data-id="element-8" />
        <WhyOthersFail data-id="element-9" />
        <UniqueMechanism data-id="element-10" />
        <StoryCredibility data-id="element-11" />
        <BenefitsTable data-id="element-12" />
        <RiskReversal data-id="element-13" />
        <UrgencyScarcity data-id="element-14" />
        <MainCTA data-id="element-15" />
        <OneLiners data-id="element-16" />
        <FAQSection data-id="element-17" />
        <MapSection data-id="element-18" />
      </main>

      <Footer data-id="element-19" />
      <RecentPurchaseToast data-id="element-20" />
    </div>;
}